/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {useEffect, useMemo} from 'react'
import CloseIcon from "@mui/icons-material/Close";
import {selectGlobalDialogState, setIsGlobalDialogOpen} from "../../../../redux/ducks/GlobalDialog/slice";
import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {IconButton} from '@mui/material';
import useGetUrlParams from "../../../../hooks/useGetUrlParams";
import {BooleanParam, useQueryParam} from "use-query-params";
import {resetVehicleProgramsState} from "../../../../redux/ducks/VehicleProgramsDetails/slice";


export const useIsGlobalDialogOpen = () => {
  const isGlobalDialogOpen = useAppSelector(selectGlobalDialogState).isOpen
  const {isGlobalDialogOpen: isGlobalDialogOpenInUrl} = useGetUrlParams()
  return isGlobalDialogOpen || isGlobalDialogOpenInUrl === '1'
}

interface IProps {
  color?: string
}
const CloseGlobalDialogButton = (props: IProps) => {
  const dispatch = useAppDispatch()
  const isGlobalDialogOpen = useAppSelector(selectGlobalDialogState).isOpen
  const {isGlobalDialogOpen: isGlobalDialogOpenInUrl} = useGetUrlParams()
  const [queryParamGlobalDialogOpen, setQueryParamGlobalDialogOpen] = useQueryParam('isGlobalDialogOpen', BooleanParam)

  const isDialogOpen = useIsGlobalDialogOpen()
  const [refresh, setRefresh] = React.useState(false);
  useEffect(() => {
    setRefresh(prevState => !prevState)
  }, [isDialogOpen]);

  const color = props.color ?? 'white'
  return (
    <>
      {isDialogOpen &&
        <IconButton>
          <CloseIcon style={{color}} onClick={() => {
            dispatch(setIsGlobalDialogOpen(false))
            setQueryParamGlobalDialogOpen(false)
            dispatch(resetVehicleProgramsState())
          }}/>
        </IconButton>
      }
    </>

  )
}

export default CloseGlobalDialogButton